import React, { useEffect } from "react";

/** Bottom sheet on phone, centred panel on tablet and laptop (salesPhone.scss). Escape closes it like a dialog. */
const SalesSheet = ({ onClose, children, label }: { onClose: () => void; children: React.ReactNode; label: string }) => {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);
  return (
    <>
      <button type="button" className="sp-dim" aria-label="Close" onClick={onClose} />
      <div className="sp-sheet" role="dialog" aria-modal="true" aria-label={label}>
        <div className="sp-grab" />
        {children}
      </div>
    </>
  );
};

export default SalesSheet;
